import { Box } from "@chakra-ui/react";
import styled from "styled-components";
import tw from "twin.macro";

export const PageWrap = styled.div`
	display: flex;
	flex-wrap: nowrap;
	width: 100%;
	${tw`font-roboto`}
`;
